import React from "react";

const InvoiceModalbyServices = ({
  invoiceData,
  invoiceNumber,
  patientName,
  doctorName,
  patientAddress,
  sale_date,
  onClose,
}) => {
  const grandTotal = invoiceData.reduce(
    (acc, item) => acc + item.quantity * item.unit_price,
    0
  );

  const formatCurrency = (amount) =>
    `Rs. ${(Number(amount) || 0).toFixed(2)}`;

  const formatDate = (dateString) => {
    if (!dateString) return "N/A";
    const d = new Date(dateString);
    return `${String(d.getDate()).padStart(2, "0")}-${String(
      d.getMonth() + 1
    ).padStart(2, "0")}-${d.getFullYear()}`;
  };

  return (
    <>
      <div
        className="fixed inset-0 z-50 flex items-center justify-center p-3 sm:p-4"
        style={{
          background: "rgba(10,37,64,0.45)",
          backdropFilter: "blur(3px)",
        }}
      >
        <div
          className="bg-white rounded-2xl shadow-2xl w-full flex flex-col"
          style={{
            maxWidth: 620,
            maxHeight: "90vh",
            animation: "slideUp 0.25s ease",
          }}
        >
          <div className="bg-[#2F6DB4] px-4 sm:px-6 py-4 rounded-t-2xl flex items-center justify-between">
            <div className="min-w-0">
              <h2 className="text-white text-[15px] sm:text-[17px] font-[500] truncate">
                Invoice Preview
              </h2>
              <p className="text-gray-200 text-[11px] sm:text-[12px] mt-0.5">
                Invoice #{invoiceNumber}
              </p>
            </div>

            <button
              onClick={onClose}
              className="w-8 h-8 rounded-full bg-white/10 hover:bg-white/20 flex items-center justify-center text-white transition-colors"
            >
              <svg
                width="14"
                height="14"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                strokeWidth="2.5"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </button>
          </div>

          <div className="overflow-y-auto flex-1 px-4 sm:px-6 py-4 sm:py-5">
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3 mb-5">
              {[
                {
                  label: "Patient",
                  value: patientName || "N/A",
                },
                {
                  label: "Doctor",
                  value: doctorName || "N/A",
                },
                {
                  label: "Address",
                  value: patientAddress || "N/A",
                },
                {
                  label: "Sale Date",
                  value: formatDate(sale_date),
                },
              ].map(({ label, value }) => (
                <div
                  key={label}
                  className="bg-gray-50 border border-gray-100 rounded-xl px-3 py-3"
                >
                  <span className="text-[10px] uppercase text-gray-400 font-[600] block mb-1">
                    {label}
                  </span>
                  <p className="text-[13px] font-[500] text-gray-800 truncate">
                    {value}
                  </p>
                </div>
              ))}
            </div>

            <div className="border border-gray-100 rounded-xl overflow-hidden mb-5">
              <div className="overflow-x-auto">
                <table className="w-full min-w-[420px]">
                  <thead>
                    <tr className="bg-[#2F6DB4] text-[11px] uppercase text-white">
                      <th className="py-2.5 px-4 text-left">Service Name</th>
                      <th className="py-2.5 px-4 text-center">Qty</th>
                      <th className="py-2.5 px-4 text-right">Unit Price</th>
                      <th className="py-2.5 px-4 text-right">Total</th>
                    </tr>
                  </thead>

                  <tbody>
                    {invoiceData.map((item, index) => (
                      <tr
                        key={index}
                        className="border-t border-gray-100 hover:bg-gray-50 text-[13px]"
                      >
                        <td className="py-3 px-4 font-[500] text-gray-800">
                          {item.service_name || "N/A"}
                        </td>
                        <td className="py-3 px-4 text-center text-gray-600">
                          {item.quantity}
                        </td>
                        <td className="py-3 px-4 text-right text-gray-600">
                          {formatCurrency(item.unit_price)}
                        </td>
                        <td className="py-3 px-4 text-right font-[500] text-gray-800">
                          {formatCurrency(item.quantity * item.unit_price)}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>

            <div className="flex justify-end">
              <div className="bg-[#2F6DB4] text-white rounded-xl px-4 sm:px-6 py-3 flex flex-wrap items-center gap-3">
                <span className="text-[11px] sm:text-[12px] uppercase tracking-wide">
                  Grand Total
                </span>
                <span className="text-[18px] sm:text-[20px] font-[600]">
                  {formatCurrency(grandTotal)}
                </span>
              </div>
            </div>
          </div>

          <div className="border-t border-gray-100 px-4 sm:px-6 py-4 flex justify-end rounded-b-2xl bg-white">
            <button
              onClick={onClose}
              className="flex items-center gap-2 border border-gray-200 text-gray-700 hover:bg-gray-50 text-[13px] font-[500] px-4 py-2 rounded-lg transition-colors"
            >
              ← Close
            </button>
          </div>
        </div>
      </div>

      <style>{`
        @keyframes slideUp {
          from { opacity: 0; transform: translateY(20px); }
          to { opacity: 1; transform: translateY(0); }
        }
      `}</style>
    </>
  );
};

export default InvoiceModalbyServices;